import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { formatNumber } from '@/lib/format'

interface PriceProps {
    value: number
    compareAt?: number | null
    size?: 'sm' | 'md' | 'lg'
    className?: string
}

const SIZES = {
    sm: { value: 'text-sm', unit: 'text-[11px]', compare: 'text-xs' },
    md: { value: 'text-base', unit: 'text-xs', compare: 'text-sm' },
    lg: { value: 'text-2xl', unit: 'text-sm', compare: 'text-base' }
}

export const Amount: FC<{ value: number, className?: string, unitClassName?: string }> = ({ value, className, unitClassName }): ReactNode => {
    return (
        <span className={cn('inline-flex items-baseline gap-1 whitespace-nowrap', className)}>
            <span className='font-bold tabular-nums'>
                {formatNumber(value)}
            </span>

            <span className={cn('font-normal text-muted-foreground', unitClassName)}>
                تومان
            </span>
        </span>
    )
}

const Price: FC<PriceProps> = ({ value, compareAt, size = 'md', className }): ReactNode => {
    const styles = SIZES[size]
    const hasDiscount = Boolean(compareAt && compareAt > value)

    return (
        <div className={cn('flex flex-wrap items-baseline gap-x-2 gap-y-0.5', className)}>
            <Amount value={value} className={cn(styles.value, hasDiscount && 'text-sale')} unitClassName={styles.unit} />

            {hasDiscount && compareAt && (
                <span className={cn('text-muted-foreground line-through decoration-1 tabular-nums', styles.compare)}>
                    <span className='sr-only'>
                        قیمت قبل:
                    </span>

                    {formatNumber(compareAt)}
                </span>
            )}
        </div>
    )
}

export default Price
